import React from 'react';

interface ExportMenuItemProps {
  type: string;
  onExport: (type: string) => void;
  id?: string;
  'data-testid'?: string;
}

const ExportMenuItem: React.FC<ExportMenuItemProps> = (props) => {
  // Map of export types to display names
  const titleMap = {
    csv: 'Export as CSV',
    xlsx: 'Export as Excel',
  };

  return (
    <button
      id={props.id}
      data-testid={props['data-testid']}
      className="w-full text-left px-4 py-2 text-base font-medium hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
      onClick={() => props.onExport(props.type)}
    >
      <span>{titleMap[props.type]}</span>
    </button>
  );
};

export default ExportMenuItem;
